<template>
  <div class="student-data__component">
    <div class="student-view__panel-content">
      <div class="panel__row">
        <student-info label="Dependentes" :value="financialData.dependents" />
        <student-info label="Renda total da família" :value="financialData.familyIncome" :filter="'currency'" />
        <student-info label="Ocupação atual" :value="financialData.incomeStatus" />
        <student-info label="Regime de trabalho" :value="financialData.jobType" />
        <student-info label="Tempo de trabalho" :value="financialData.workAge" />
      </div>
      <div class="panel__row">
        <student-info label="Renda atual" :value="financialData.income" :filter="'currency'" />
        <student-info label="CEP do trabalho" :value="financialData.workZipCode" />
        <student-info label="Estado" :value="financialData.workState ? financialData.workState.name : ''" />
        <student-info label="Cidade" :value="financialData.workCity ? financialData.workCity.name : ''" />
        <student-info label="Bairro" :value="financialData.workNeighborhood" />
      </div>
    </div>
  </div>
</template>
<script>
import StudentInfo from 'components/StudentInfo';

export default {
  components: {
    StudentInfo,
  },
  props: {
    financialData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
